if ($('[data-regon="pdfListingResults"]').length > 0) {
    var Bunge = Bunge || {};

    Bunge.pdfListings = (function($) {
        var ui = {};
        function cacheUI() {
            ui.$listingRegon = $('[data-regon="pdfListingResults"]');
            ui.$searchWrapper = $('[data-regon="searchWrapper"]');
            ui.loader = $('[data-control="pageLoader"]');
            ui.$resultInfo = $('[data-regon="resultinfo"]');
        }

        function init() {
            if ($('[data-regon="pdfListingResults"]').length <= 0) {
                return;
            }
            cacheUI();
        }

        $('#main-filter').change(function() {
            let choice = $('#main-filter :selected').text();
            let value = $('#main-filter :selected').val();

            $('.listing__result-info').html(choice);

            if (value == 'all-regions') {
                $('.-pdf-listing [data-regions]').show();
            } else {
                $('.-pdf-listing [data-regions]').hide();
                let filterItems = $(
                    '.-pdf-listing [data-regions*="' + value + '"]'
                );
                $(filterItems).show();
            }
        });

        return {
            init: init,
        };
    })(jQuery);

    $(function() {
        Bunge.pdfListings.init();
        $('.listing__results-container').addClass('-active');
    });
}
